export default __webpack_public_path__ + "static/media/arrow-drop-up.97f9f66c.svg";